import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import { fetchQuestions } from "../../../store/questionBank/action";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";

function QuestionBankTab() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const questions = useSelector(
    (state) => state?.QuestionBankReducer?.questions
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchQuestions());
  }, []);

  return (
    <div>
      <Row className="mb-3">
        <Col lg={12}>
          <div className="d-flex flex-row align-items-baseline justify-content-between">
            <div className="mb-3">
              <span className="fs-5 fw-semibold">Question Bank</span>
            </div>
            <div className="d-flex flex-row align-items-baseline gap-2">
              <div className="search-box">
                <input
                  placeholder="Search.."
                  type="text"
                  className="form-control"
                  style={{ width: "300px", borderColor: "#F7F8FC" }}
                />
                <span className="search-icon mdi mdi-magnify"></span>
              </div>
              <Dropdown
                isOpen={dropdownOpen}
                toggle={() => setDropdownOpen(!dropdownOpen)}
                direction="down"
              >
                <DropdownToggle
                  caret
                  style={{
                    backgroundColor: "#3F88E4",
                    color: "#fff",
                    borderRadius: "8px",
                  }}
                >
                  + New
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => navigate("/assessment/create")}>
                    New Assessment
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => navigate("/assessment/question-bank")}
                  >
                    New Question
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Button
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #C3D3E2",
                  borderRadius: "8px",
                }}
                className="d-flex flex-row align-items-baseline gap-1"
              >
                <span className="mdi mdi-filter-variant"></span>
                <span>Filter</span>
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          {questions.map((question, index) => {
            return (
              <Card
                style={{
                  backgroundColor: "#F9FCFF",
                  border: "1px solid #7AC7FF",
                  padding: "8px",
                  borderRadius: "8px",
                }}
                key={index}
              >
                <CardBody>
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex flex-row align-items-baseline justify-content-between">
                      <div style={{ fontSize: "18px" }}>
                        {question?.questionTitle}
                      </div>
                      <div className="mdi mdi-dots-horizontal cursor-pointer"></div>
                    </div>

                    <div
                      className="d-flex flex-row gap-2 align-items-baseline"
                      style={{ color: "#7F7F7F" }}
                    >
                      <div className="d-flex flex-row gap-1 align-items-baseline">
                        <span
                          className="fw-semibold"
                          style={{ color: "#3F88E4" }}
                        >
                          {question?.level}
                        </span>
                        <span>Level</span>
                      </div>

                      <span>|</span>

                      <div className="d-flex flex-row gap-1 align-items-baseline">
                        <span
                          className="fw-semibold"
                          style={{ color: "#3F88E4" }}
                        >
                          {question?.questiontype}
                        </span>
                        <span>Type</span>
                      </div>

                      <span>|</span>

                      <div className="d-flex flex-row gap-1 align-items-baseline">
                        <span
                          className="fw-semibold"
                          style={{ color: "#3F88E4" }}
                        >
                          {question?.difficulty}
                        </span>
                        <span>Difficulty</span>
                      </div>

                      <span>|</span>

                      <div className="d-flex flex-row gap-1 align-items-baseline">
                        <span
                          className="fw-semibold"
                          style={{ color: "#3F88E4" }}
                        >
                          {question?.topic}
                        </span>
                        <span>Topic</span>
                      </div>
                    </div>

                    <div
                      className="d-flex flex-row gap-2 align-items-baseline"
                      style={{ color: "#7F7F7F" }}
                    >
                      <div
                        className="d-flex flex-row gap-1 align-items-baseline"
                        style={{
                          backgroundColor: "#fff",
                          borderRadius: "8px",
                          padding: "4px 8px",
                        }}
                      >
                        <span className="mdi mdi-account-edit-outline"></span>
                        <span
                          className="fw-semibold"
                          style={{ color: "#3F88E4" }}
                        >
                          {question?.name}
                        </span>
                      </div>
                      <div
                        className="d-flex flex-row gap-1 align-items-baseline"
                        style={{
                          backgroundColor: "#fff",
                          borderRadius: "8px",
                          padding: "4px 8px",
                        }}
                      >
                        <span className="mdi mdi-calendar-edit"></span>
                        <span
                          className="fw-semibold"
                          style={{ color: "#3F88E4" }}
                        >
                          {format(
                            new Date(question?.createdAt),
                            "MMM d, yyyy, h:mm a"
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            );
          })}
        </Col>
      </Row>
    </div>
  );
}

export default QuestionBankTab;
